module.exports = __webpack_public_path__ + "img/Delete.cb740f3a.svg";